import type { EnumType } from "@pdfking/structs"
import type { StringGUID } from "@pdfking/tfunc"

export const enum TrackingEnum {
  START = "start",
  STOP = "stop",
  STATUS = "status",
}

export type TrackingStatus = {
  done: number
  name: string
  total: number | undefined
}

export type TrackingMessage =
  | EnumType<TrackingEnum.START, { guid: StringGUID }>
  | EnumType<
      TrackingEnum.STOP,
      {
        guid: StringGUID
        error: EnumType<string | number> | undefined
      }
    >
  | EnumType<TrackingEnum.STATUS, { guid: StringGUID } & TrackingStatus>

export type TrackingCallback = (message: TrackingMessage) => void
